import mapper from 'object-mapper';
import { filter, uniqBy, set, groupBy } from 'lodash';
import moment from 'moment';
import { ScheduleRecord, OrderInfoRecord, OrdersRecord, TravellerRecord } from './../../../Record/Orders';
import { add } from './../../Decimal';

const OrderMapper = {
  '[].订单号': {
    'key': '[].ordersn',
  },
  '[].联系人姓名': {
    'key': '[].name',
  },
  '[].联系人手机': {
    'key': '[].phone',
  },
  '[].商家备注': {
    'key': '[].web_remark',
  },
  '[].出行人信息': {
    'key': '[].traveller[]',
    default: [],
    transform: (value) => {
      if (typeof value !== 'string' || value === '') {
        return value;
      }
      const pattern = /([^;]+).*?/g;
      const arr = value.match(pattern);
      const as = arr.map((r) => {
        const p2 =
          /(出行人姓名:(?<traveller_name>[,]*[^,;]+)),(证件号:(?<credentials_code>[,]*[^,;]*)),(电话号码:(?<telphone>[,]*[^,;]*))/g;
        const rr = p2.exec(r)?.groups;
        return {...rr, credentials_type: 0, sex: rr?.credentials_code ? (String(rr?.credentials_code).slice(-2,-1)%2) : ''};
      });
      return as;
    },
  },
  // '[].备注': {
  //   'key': '[].web_buyer_message'
  // },

  // is_click_farm: 0,      // 刷单 1（刷单）/ 0 （正式单） orders.is_click_farm
  // farm_cost: 0,          // 刷单费用
};
// transform
const InfoMapper = {
  '[].订单号': {
    'key': '[].ordersn',
  },
  '[].确认时间': {
    'key': '[].booking_date',
    'transform': (value) => moment(value).format('YYYY-MM-DD HH:mm:ss'),
  },
  '[].出发日期': {
    'key': '[].departure_date',
    'transform': (value) => moment(value).format('YYYY-MM-DD HH:mm:ss'),
  },
  '[].预定项目': {
    'key': '[].product_name',
  },
  '[].预定份数': {
    'key': '[].num',
  },
  '[].底价': [{ 'key': '[].payment' }, { 'key': '[].transaction_amount' }],

  // o_id: '',
  // oi_id: 'oi_id_0',
  // sub_o_id: uuid(),
  // status_code: 'Z_1',    // 订单状态 orders_information.status
  // commission: '',        // 佣金 orders_information.commission
  // profit: '',            // 利润 orders_information.profit
  // profit_margin: '',     // 利润率 orders_information.profit_margin
  // commission_rate: 0,    // 佣金比率 orders_information.commission_rate
  // web_settlement: '',    // 平台结算价 orders_information.web_settlement
  // supplier_offer: '',    // 供应商报价 orders_information.supplier_offer
  // supplier_tax: '',      // 供应商报价税额 orders_information.supplier_tax
  // supplier_tax_point: '0',// 供应商报价税点 orders_information.supplier_tax_point
  // unit_id: 0,            // 单位id
  // sku_code: '',          // 产品编码
  // order_types: 2,        // 订单类型
  // transaction_amount: 0,
  // settlement_price: 0,
  // refund_fee: 0,
  // replenish_fee: 0,
};

const getRemark = (str = '') => {
  const _str = str.slice(str.indexOf('操作内容'));
  const arr = _str.split(':');
  if (arr.length === 0) {
    return '';
  }
  return arr.splice(1).join(':');
};

const formatBaseData = (data) => {
  let r;
  r = filter([].concat(data.Sheet0 || []), (item) => item['底价'] != 0);
  return r;
};

const formatOrders = (data) => {
  let r;
  r = [].concat(data);
  r = mapper(r, OrderMapper);
  r = uniqBy(r, 'ordersn').map((item) => set(item, 'web_remark', getRemark(item.web_remark)));
  return r;
};

const formatInfo = (data) => {
  let r;
  r = [].concat(data);
  r = mapper(r, InfoMapper);
  r = groupBy(r, 'ordersn');
  for (const key in r) {
    if (Reflect.has(r, key)) {
      let o = {},
        pn = [];
      r[key].forEach((item) => {
        pn.push(item.product_name);
        o = {
          ...item,
          'payment': (o.payment || 0) + +item.payment,
          'transaction_amount': (o.transaction_amount || 0) + +item.transaction_amount,
        };
      });
      r[key] = { ...o, 'product_name': pn.join('+') };
    }
  }
  return r;
};

export default (data, shop_id) => {
  // console.clear();
  const baseData = formatBaseData(data);
  let r0, r1, r2;
  r0 = formatOrders(baseData);
  r1 = formatInfo(baseData);
  // init order
  r0 = r0.map((item) => {
    let order = new OrdersRecord(item).toJS();
    let info = [new OrderInfoRecord({ ...r1[item.ordersn] }).toJS()];
    set(
      order,
      'total_fee',
      info.reduce((s, oi) => add(s, oi.transaction_amount), 0)
    );
    set(order, 'pf_id', 3);
    set(order, 'shop_id', shop_id);
    set(order, 'orders_info', info);
    return order;
  });
  return r0;
};
